export const OUTER_LIBRARY_ID = 'outer-library';
export const DEFAULT_ELEMENT_ID = '0';

